<div class="flex flex-col flex-auto w-full">
  <div class="container">
    <div class="top-header">
      <div class="page-title">OutWard Branch Inventory List</div>
      <div class="header-right">
        <div class="breadcrumb">
          <span>Home</span>
          <span class="separator">/</span>
          <span>Inventory</span>
          <span class="separator">/</span>
          <span>OutWard Branch Inventory List</span>
        </div>
        <button class="go-back-btn" (click)="goBack()">Go Back</button>
      </div>
    </div>

    <div class="sub-header">
      <div class="label">OutWard Branch Inventory List</div>
      <button class="export-btn" (click)="exportToExcel()">Export to Excel</button>
    </div>

    <div class="table-container">
      <div class="table-controls">
        <div class="entries-select">
          Show
          <!-- Was a DevExtreme select box with [items] / [(value)] / (onValueChanged).
               nz-select emits the VALUE directly, whereas onValueChanged emitted an
               event object - onPageSizeChange(newPageSize: number) was therefore
               being handed an object, and only worked because updateGrid() re-reads
               this.pageSize from the two-way binding. Passing the value fixes that. -->
          <nz-select style="width: 80px"
                     [(ngModel)]="pageSize"
                     (ngModelChange)="onPageSizeChange($event)">
            <nz-option [nzValue]="10" nzLabel="10"></nz-option>
            <nz-option [nzValue]="20" nzLabel="20"></nz-option>
            <nz-option [nzValue]="50" nzLabel="50"></nz-option>
          </nz-select>
          entries
        </div>
       
      </div>

      <!-- [pageSize] is bound, not the literal 10 the converter emitted: the original
           used the object form [paging]="{ pageSize: pageSize }", which the converter
           does not read, so the "Show N entries" selector above would have gone dead. -->
      <app-data-grid [dataSource]="listOfData"
                    [searchPanel]="false"
                    [filterRow]="false"
                    [filterPanel]="false"
                    [groupPanel]="false"
                    [columnChooser]="false"
                    [allowExport]="false"
                    [pageSize]="pageSize"
                    [allowedPageSizes]="[10, 20, 50]"
                    [showPageSizeSelector]="true"
                    [showBorders]="true">
        

        
                    <app-grid-column dataField="sno" caption="S.No" [allowSorting]="true"></app-grid-column>

        
                    <app-grid-column dataField="fromBranch" caption="From Branch" [allowSorting]="true"></app-grid-column>

        
                    <app-grid-column dataField="toBranch" caption="To Branch" [allowSorting]="true"></app-grid-column>

        
                    <app-grid-column dataField="delivery" caption="Delivery" [allowSorting]="true"></app-grid-column>

        
                    <app-grid-column dataField="detail" caption="Detail" [allowSorting]="true"></app-grid-column>

        
                    <app-grid-column dataField="challanNo" caption="Challan No" [allowSorting]="true"></app-grid-column>

        
                    <app-grid-column dataField="category" caption="Category" [allowSorting]="true"></app-grid-column>

        
                    <app-grid-column dataField="inventory" caption="Inventory" [allowSorting]="true"></app-grid-column>

        
                    <app-grid-column dataField="make" caption="Make" [allowSorting]="true"></app-grid-column>

        
                    <app-grid-column dataField="model" caption="Model" [allowSorting]="true"></app-grid-column>

        
                    <app-grid-column dataField="serial" caption="Serial" [allowSorting]="true"></app-grid-column>

        
                    <app-grid-column dataField="qty" caption="Qty" [allowSorting]="true"></app-grid-column>

        
                    <app-grid-column dataField="macAddress" caption="MAC Address" [allowSorting]="true"></app-grid-column>

      </app-data-grid>
    </div>
  </div>
</div>
